import { observer } from "mobx-react-lite";
import { Video } from "../../../../../../app/store/types";
import { useEffect, useRef, useState } from "react";
import { extractFirstFrame } from "../../../../utils/extractFirstFrame";
import { useVideoStore } from "../../../../../../shared/hooks/useVideoStore";
import {
    NumberSC,
    VideoCardSC,
    ContentSC,
    VideoPreviewSC,
    TextContentSC,
    TextSC,
} from "./styled";
import AudioPlayer from "./components/AudioPlayer";

interface VideoCardProps {
    video: Video;
    index: number;
}

export const VideoCard = observer(({ video, index }: VideoCardProps) => {
    const videoStore = useVideoStore();
    const [thumbnail, setThumbnail] = useState<string>("");
    const hoverTimeoutRef = useRef<number>(0);

    useEffect(() => {
        if (video.url) {
            extractFirstFrame(video.url).then(setThumbnail);
        }
    }, [video.url]);

    const handleMouseEnter = () => {
        hoverTimeoutRef.current = window.setTimeout(() => {
            // videoStore.openVideo(video);
        }, 300); // Small delay to prevent accidental triggers
    };

    const handleClick = () => {
        videoStore.openVideo(video);
    };

    const handleMouseLeave = () => {
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
        }
    };

    useEffect(() => {
        return () => {
            if (hoverTimeoutRef.current) {
                clearTimeout(hoverTimeoutRef.current);
            }
        };
    }, []);

    return (
        <VideoCardSC>
            <NumberSC>{index + 1}</NumberSC>
            <ContentSC>
                <VideoPreviewSC
                    imgUrl={video.frames ? video.frames : "#334155"}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    onClick={handleClick}
                />
                <TextContentSC>
                    <TextSC>{video.text}</TextSC>
                    <AudioPlayer audioUrl={video.audioUrl} />
                </TextContentSC>
            </ContentSC>
        </VideoCardSC>
    );
});
